(function () {
  'use strict';

  angular.module('app').component('confirmXmlsPage', ConfirmXmlsPageComponent());

  function ConfirmXmlsPageComponent() {
    return {
      bindings: {},
      controller: ConfirmXmlListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/confirm-xmls/confirm-xmls-page.component.html',
    };
  }

  ConfirmXmlListCtrl.$inject = [
    'CONFIGURATIONS',
    '$location',
    'AbilityService',
    'ConfirmXmlService',
    'SessionService',
  ];

  function ConfirmXmlListCtrl(
    config,
    $location,
    AbilityService,
    ConfirmXmlService,
    SessionService
  ) {
    const vm = this;

    // vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled; / what for ?

    // public properties
    // -----------------------
    vm.permissions = {
      canCreate: AbilityService.can('create_confirmxml_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY_SHORT_HOUR;

    // private properties
    // -----------------------
    let companyId = SessionService.getSelectedAccountCompany().id;

    // public methods
    // -----------------------
    vm.getXmlInbox = function () {
      getItems();
    };

    vm.createConfirmXml = function (file) {
      $location.path('/confirm_xmls/new').search({ mode: 'xml', xml: file });
    };

    vm.onShowConfirmXml = function (item, mode) {
      $location.path(`/confirm_xmls/${item.id}`).search({ mode: mode });
    };

    // private methods
    // -----------------------
    getItems();
    // getXmlInboxLastUpdated(); // TODO: willy

    // Here we can call factun instead of api cronjob

    function getItems() {
      vm.loadingItems = true;
      ConfirmXmlService.getConfirmXmls().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalAmounts = vm.items.totalAmounts;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    }

    /* function getXmlInboxLastUpdated() {
      let params = {
        skip_check_role: true,
      };

      ConfirmXmlService.getXmlInboxLastUpdated(companyId, params).then(function (data) {
        vm.inboxLastUpdated = data;
      });
    } */
  }
})();
